import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Re-export commonly used lib modules
export { queryClient, createQueryClient } from './queryClient'
export { ApiClient, createApiClient } from './apiClient' 